"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _material = require("@mui/material");
var _layout = _interopRequireDefault(require("../../attrs/layout"));
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var StyledAppBar = (0, _styledComponents["default"])(_material.AppBar)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-top: ", "px;\n  &.MuiPaper-root {\n    z-index: 2;\n  }\n  &.MuiPaper-elevation4 {\n    box-shadow: none;\n  }\n  &.withPageHeader {\n    margin-top: ", "px;\n  }\n"])), _layout["default"].navbarHeight, _layout["default"].pageHeaderBarHeight + _layout["default"].navbarHeight);
var _default = exports["default"] = StyledAppBar;